export const bankName = 'Barclays';

export const faqContent = (campaignDefaults) => [
  {
    title: "Overview", content: [
      {
        question: "What is a personal loan?",
        description: "Personal loans are offered to individual borrowers who demonstrate a proven ability to manage credit. These loans are unsecured, meaning they don’t require collateral such as a home or a car. Most often, personal loans are used to consolidate debt, to pay for a life event such as a wedding or a once‐in‐a‐lifetime vacation, or to finance a major purchase."
      },
      {
        question: "How much money can I borrow?",
        description: `With a ${ bankName } Personal Loan, qualified applicants can borrow any amount from $5,000 to $35,000, with a payoff term of 36, 48 or 60 months.`
      },
      {
        question: "What is the APR?",
        description: `The annual percentage rates (APR) offered on our personal loans currently range from ${campaignDefaults.minApr}% to ${campaignDefaults.maxApr}%, depending on the borrower's credit history. These rates are fixed and do not vary with changes in the prime rate.`
      },
      {
        question: "How long does the application process take?",
        description: "You can apply online in just a few minutes. If you provide all the necessary information, we may be able to give you a decision that same day, although most loan applications will take a few days to complete."
      },
      {
        question: "Are there any fees for applying?",
        description: `No. There are no loan origination fees – or fees of any kind – on the ${ bankName } Personal Loan product.`
      },
      {
        question: "When can I receive the funds?",
        description: `After you’ve been approved for a ${ bankName } Personal Loan, you’ll receive your funds in a few business days.`
      }]
  },
  {
    title: "Application process", content: [
      {
        question: "How do I apply?",
        description: "Just click Check your rate and follow the prompts. Then choose the term/APR that meets your needs. Our 100% online application process will help you track the progress of your application, upload your information and documents, and receive updates about the progress of your application over the web."
      },
      {
        question: "Will checking my rate affect my credit score?",
        description: "No. Checking your rate will not affect your credit score. We simply use a “soft” credit inquiry to gauge your creditworthiness. This is not reported to creditors or the credit reporting agencies."
      },
      {
        question: "Will you check my credit score when I actually apply?",
        description: "Yes, but only after you submit your application – not when you are checking your rate. Your credit score and other information in your credit history will help us determine your creditworthiness."
      },
      {
        question: "What information do you need from me?",
        description: "Your name, address, contact information, Social Security number, and your employment and financial background. Be sure to have your information handy before you fill out our online application."
      },
      {
        question: `Do I have to put up collateral for a ${ bankName } Personal Loan?`,
        description: `No. The ${ bankName } Personal Loan is unsecured – meaning that you don’t need collateral. You qualify for a loan based on your credit history, income and other factors.`
      },
      {
        question: "Do I need to send you any written documentation?",
        description: "We will need certain documents to evaluate your loan application. You can upload them through our secure Application Center, which supports the following file formats: .pdf, .doc, .jpg, .gif, .png and .bmp."
      },
      {
        question: "Will you tell me which documents you want me to upload?",
        description: "Yes. We’ll let you know in a message sent through our secure Application Center."
      },
      {
        question: "What if I decide to cancel my loan application after I submit it?",
        description: "You may cancel your loan application any time before you sign for it electronically."
      },
      {
        question: "Will you share my personal information with anyone?",
        description: "No. We won’t share your personal information, but we will use it to check your credit history."
      }]
  },
  {
    title: "Receiving your loan", content: [
      {
        question: "How long will it take to get my loan?",
        description: `${bankName } will distribute the funds in a few business days. Delays may occur based on your financial institution’s policies and procedures.`
      },
      {
        question: "Can I choose how to receive my funds?",
        description: "Yes. You can have your funds deposited into a U.S. checking or savings account, or you can have us pay off up to 5 credit card balances directly."
      }]
  },
  {
    title: "Making payments", content: [
      {
        question: "Will I receive account statements each month?",
        description: `No. There are no paper statements for the ${ bankName } Personal Loan. You can view your payment and transaction history through our secure customer service website.`
      },
      {
        question: "How do I make payments on my loan?",
        description: "You’ll pay online through our secure customer service website. You can set up automatic repeat payments, or you can log in each month and pay us electronically."
      },
      {
        question: "Can I set up automatic repeat payments?",
        description: "Absolutely! Just sign up for automatic repeat payments, at no extra charge, and we’ll automatically deduct your payment from the U.S. checking or savings account that you’ve designated. Want to pay off your loan faster? Just pay more than the amount due each month."
      },
      {
        question: "Can I change my payment due date?",
        description: `Yes. Once you’re approved for a ${ bankName } Personal Loan, you can select a due date different from the one we’ve given you. Please remember that changing your payment due date can affect your monthly payment amount and/or your final loan payment amount.`
      },
      {
        question: "What if I’m late with a payment?",
        description: "If you don’t make your monthly payment on time, your loan balance will continue to accrue interest, which could affect your total loan repayment amount. There are no late fees for missing your payment due date. We’ll send you email notifications when your payments are due. We’ll also email you if you’ve missed a payment."
      },
      {
        question: "Can I pay my loan off early, without penalty?",
        description: "Yes. There are no prepayment penalties. You can pay your loan off faster by making larger payments or extra payments each month."
      }]
  },
  {
    title: "Online Servicing", content: [
      {
        question: "Can I manage my loan account online?",
        description: "Yes. Just log in to our secure customer website to check your balance, make payments, set up automatic repeat payments, and more."
      },
      {
        question: "Can I access my loan account from my cell phone?",
        description: "Yes. You can access our website through your mobile device."
      },
      {
        question: "What if I forget my online password?",
        description: "Click the Forgot Password link to regain access to our secure customer website."
      }]
  }
];

export const flexibleTerms = [
  {
    row: [{
      title: "$0 in fees",
      description: "With a Barclays Personal Loan, you'll pay no fees of any kind"
    }, { title: "Quick rate check", description: "Checking your rate won't affect your credit score" }]
  },
  {
    row: [{
      title: "Flexibility",
      description: "Choose your payment due date or; pay off your loan early"
    }, { title: "Financial Freedom", description: "Break free from the burden of high-interest debt" }]
  }
];
